package com.shadowings.gero.data.lessons.chapter6
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs1WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs2WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs3WordIds


import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.MultiPressPair
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_alyn_1
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_alyn_2
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_nilo_1
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_zeta_1
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_zeta_2
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_zeta_3
import gero.composeapp.generated.resources.exp_content_recap_imperfettivo_zeta_4
import gero.composeapp.generated.resources.exp_title_recap_imperfettivo
import gero.composeapp.generated.resources.question_type_multipress

fun getRecapImperfettivoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_zeta_1,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_alyn_1,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_zeta_2,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_zeta_3,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_zeta_4,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_imperfettivo,
            content = Res.string.exp_content_recap_imperfettivo_nilo_1,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
    )
}

fun getRecapImperfettivoQuiz(
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String
): List<IQuizContent> {
    val verbKeysToUse = (listOf("VEDERE", "SCRIVERE", "PARLARE") + listOf(
        "MANGIARE",
        "DARE",
        "ASCOLTARE",
        "DIRE",
        "BERE",
        "USCIRE",
        "ENTRARE",
        "AMARE",
        "ESISTERE",
        "VOLARE"
    ).shuffled().take(7)).shuffled()
    val pronouns = listOf(
        "IO", "TU_M", "TU_F", "EGLI", "ELLA", "ESSO", "NOI", "VOI", "ESSI"
    )

    val keyboardQuiz = verbKeysToUse.take(4).map { verbKey ->
        val result = getRandomImperfectiveConjugation(verbKey, pronouns, words, verbs, languageCode)
        PhoneticKeyboardContent(
            sentence = result.hieroglyphs,
            info = "${result.transliteration} -> ${result.sentence}",
            reading = result.transliteration.map { it.toString() },
            isProperName = false,
            canRotate = false
        )
    }

    val translationQuiz = verbKeysToUse.drop(5).take(5).map { verbKey ->
        val result = getRandomImperfectiveConjugation(verbKey, pronouns, words, verbs, languageCode)
        TextTranslationContent(
            hieroglyphs = result.hieroglyphs,
            correctPhrase = result.sentence,
            transliteration = result.transliteration
        )
    }

    val verbs =
        words.filter { it.id in vocabVerbs1WordIds + vocabVerbs2WordIds + vocabVerbs3WordIds + vocabVerbs4WordIds }
            .shuffled().take(4)

    val multiPressQuiz = listOf(
        MultiPressContent(
            pairs = verbs.map {
                MultiPressPair(hieroglyphs = it.gardiner, meaning = it.getMeaning(languageCode))
            },
            prompt = Res.string.question_type_multipress
        )
    )

    return keyboardQuiz + translationQuiz + multiPressQuiz
}